import { useState } from 'react'
import { httpClient } from '../../shared/api/httpClient'
import { useAuth } from '../../shared/context/AuthContext'
import { useAstreaEnvironment } from '../../shared/hooks/useAstreaEnvironment'
import { useFeatureToggleMutation, useSaveFeatureToggleLogMutation } from './useFeatureToggle'

const EMAIL_MARKER = '@'

export function useTenantToggleOperation() {
  const { getUserLogin } = useAuth()
  const { urlAstreaPath } = useAstreaEnvironment()
  const toggleMutation = useFeatureToggleMutation()
  const logMutation = useSaveFeatureToggleLogMutation()
  const [resolving, setResolving] = useState(false)

  async function resolveTenantIdFromEmail(email) {
    const response = await httpClient.get(`${urlAstreaPath}/api/v2/contracts`, {
      params: { email },
    })
    const { status, data } = response

    if (status !== 200 || !data || !data.info || data.info.length !== 1) {
      return null
    }

    return data.info[0].tenantId
  }

  async function run({ feature, operation, target, reason }) {
    const trimmedTarget = target.trim()
    let tenantId = trimmedTarget

    if (trimmedTarget.includes(EMAIL_MARKER)) {
      setResolving(true)
      try {
        tenantId = await resolveTenantIdFromEmail(trimmedTarget)
      } finally {
        setResolving(false)
      }

      if (tenantId == null) {
        return { status: 'error' }
      }
    }

    const response = await toggleMutation.mutateAsync({ operation, feature, tenantId })

    if (response.status === 204) {
      try {
        await logMutation.mutateAsync({
          who: getUserLogin(),
          feature,
          operation,
          target: trimmedTarget,
          reason,
        })
      } catch {
        return { ...response, logFailed: true }
      }
    }

    return response
  }

  return {
    run,
    isPending: resolving || toggleMutation.isPending || logMutation.isPending,
  }
}
